goog.provide('el8.appshared.feedItemPlrActions');

goog.require('el8.appchart.dialog.plrPreview');
goog.require('el8.appservice.notifier');

//
// Returned fn takes two params:
// - item
el8.appshared.feedItemPlrActions = (function() {

    return function(item) {
        if (!item) { return null; }
        var menu = [];

        menu.push({
            actionText: 'Preview',
            actionFn: function() {
                el8.appchart.dialog.plrPreview.show(item.getId());
                el8.util.amplitude.logPLRChronologicalPreviewItem({type: item.rawData.type.name, source: "Chronological Record"});
            }
        });

        menu.push({
            actionText: 'Import And Sign',
            actionFn: function() {
                el8.appservice.notifier.notify('Signing this document into your chart...');
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('plrChartImportItem', [item.getPatientId(), item.getId()]),
                    success: function(data) {
                        el8.appservice.notifier.notify('Document has been signed into your chart.');
                        var mClass = data.new_item.model_class;
                        var entitySet = el8.ptdata.getEntitySet(mClass);
                        entitySet.create(data.new_item);

                        el8.appchart.mainFeeds.plrNotification.refresh();
                        el8.appchart.mainFeeds.chart.refreshChartSearch();
                    }
                });
                el8.util.amplitude.logPLRChronologicalImportSignItem({type: item.rawData.type.name, source: "Chronological Record"});
            }
        });


        // Rather than wrap each menu item in an if statement, remove all items here that should not be
        // shown in read-only mode
        if (el8Globals.READ_ONLY) {
            menu = _.filter(menu, function (item) { return item.allowReadonly; });
        }

        return menu;
    };

})();
